<div class="limits-reminder">
	<div class="limits-reminder-description">
		<div class="limits-reminder-description-ico">
			<span class="ico ico-deposit-limit-shield"></span>
		</div>

		<p class="limits-reminder-description-text">{{ "limits-reminder.content" | translate }}</p>
	</div>

	<div class="limits-reminder-info" *ngIf="limitsSummary; else obgSpinner">
		<div class="limits-reminder-info-container">
			<ng-container *ngIf="limitsSummary.balanceLimitInfoResponse">
				<div class="limit-info-block">
					<h3>{{ "limits-reminder.balance" | translate }}</h3>
					<p
						class="limit-info-block-text highlighted large"
						test-id="limits-reminder-balance"
						obgSensitiveData
					>
						{{ balance.totalAmount | obgCurrency }}
					</p>
				</div>

				<div class="limit-info-block">
					<p class="limit-info-block-text light small">{{ "limits-reminder.balance-limit" | translate }}</p>
					<p class="limit-info-block-text small" obgSensitiveData>
						{{ limitsSummary.balanceLimitInfoResponse.amount | obgCurrency }}
					</p>
				</div>
				<hr />
			</ng-container>

			<ng-container *ngIf="limitsSummary.depositLimitInfoResponse">
				<div class="limit-info-block">
					<h3>{{ "limits-reminder.deposit" | translate }}</h3>
					<p class="limit-info-block-text highlighted large" obgSensitiveData>
						{{ limitsSummary.depositLimitInfoResponse.usedValue | obgCurrency }}
					</p>
				</div>

				<div class="limit-info-block">
					<p class="limit-info-block-text light small">{{ "limits-reminder.deposit-limit" | translate }}</p>
					<p class="limit-info-block-text small" obgSensitiveData>
						{{ limitsSummary.depositLimitInfoResponse.thresholdValue | obgCurrency }}
					</p>
				</div>
				<hr />
			</ng-container>

			<ng-container *ngIf="limitsSummary.sessionLimitInfoResponse">
				<div class="limit-info-block">
					<h3>{{ "limits-reminder.session" | translate }}</h3>
					<p class="limit-info-block-text highlighted large">
						{{
							"limits-reminder.used-session-limit"
								| translate
									: {
											hours: usedSessionLimitDurationHours,
											minutes: usedSessionLimitDurationMinutes,
									  }
						}}
					</p>
				</div>

				<div
					class="limit-info-block"
					*ngIf="limitsSummary.sessionLimitInfoResponse.sessionTimeLimitExpireType !== 'None'"
				>
					<p class="limit-info-block-text light small">{{ "limits-reminder.session-limit" | translate }}</p>
					<p class="limit-info-block-text small">
						{{
							"limits-reminder.current-session-limit"
								| translate
									: {
											time: sessionLimitDurationHours,
											period:
												"limits-reminder.session." +
													limitsSummary.sessionLimitInfoResponse.sessionTimeLimitExpireType
												| lowercase
												| translate,
									  }
						}}
					</p>
				</div>
			</ng-container>

			<div class="last-login-timestamp-container" *ngIf="showLastLoginTimestamp()">
				<p
					class="last-login-timestamp"
					*ngIf="lastLoginTimestamp$ | async as lastLoginTimestamp"
					[translate]="'limits-reminder.last-login-timestamp'"
					[translateParams]="{
						date: lastLoginTimestamp.date,
						time: lastLoginTimestamp.time,
					}"
				></p>
			</div>
		</div>
	</div>

	<ng-template #obgSpinner>
		<div class="overlay">
			<div class="obg-spinner"></div>
		</div>
	</ng-template>

	<div class="limits-reminder-responsible-gaming">
		<div
			(click)="onCloseAnchorClick($event.target.nodeName)"
			[innerHTML]="'limits-reminder.responsible-gaming' | translate"
		></div>
	</div>

	<div class="limits-reminder-controls">
		<ng-container *ngIf="!isShowAfterLogout">
			<button
				mat-button
				color="primary"
				test-id="limits-reminder-button-change-limits"
				(click)="redirectToResponsibleGaming()"
			>
				{{ "limits-reminder.button.change-limits" | translate }}
			</button>

			<button mat-button color="primary" test-id="limits-reminder-button-continue" (click)="closeModal()">
				{{ "limits-reminder.button.continue" | translate }}
			</button>
		</ng-container>

		<ng-container *ngIf="isShowAfterLogout">
			<button mat-button color="primary" test-id="limits-reminder-button-close" (click)="closeModal()">
				{{ "limits-reminder.button.close" | translate }}
			</button>
		</ng-container>
	</div>
</div>
